import icon from './assets/icon.svg';
import thumbnail from './assets/thumbnail.png';
import operation from './Commands/operation';
import setup from './Commands/setup';
import Dashboard from './Dashboard';
import MapMapper from './MapMapper';

const map = {
  commandGroups: { setup, operation },
  Dashboard,
  icon,
  MapMapper,
  thumbnail,
};

export default map;
